import React, { useState, useEffect, useMemo } from 'react';
// material-ui
import { Box, Button, Card, Grid, Switch, Tab, Tabs } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import {
    getMerchantWizardState,
    setMerchantWizardState,
    clearMerchantWizardState,
    useResetMerchantWizardOnLeave
} from 'helper/MerchantWizard';

// project imports
import { getParamsFromURL } from 'helper/Params';

// import AddCourtComponent from './component/addCourtComponent';
import DropZoneComponent from 'components/DropzoneComponent';
// import OperationalHoursComponent from './component/operationalHoursComponent';
import { TCInput } from 'components/TopCourtComponents/Input/TopCourtInput';
import { TCLabel, TCTitleLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';

import { createPlaces, getPlaceDetail, updatePlaces, setCourtsRainRefund, getPlaces } from 'services/placeServices';
import { handleUpload } from 'helper/S3';

import { validation } from 'helper/Form';

import {
    DragDropContext,
    Droppable,
    Draggable
} from "react-beautiful-dnd";
import { toastMessage } from 'components/Toast/Toast';
import AddCourtComponent from '../courts/component/addCourtComponent';
import OperationalHoursComponent from '../courts/component/operationalHoursComponent';
import { createMerchant, setMerchantRainRefund, updateMerchant } from 'services/merchantServices';
import MerchantPartnerFee from './component/merchantPartnerFee';
import MerchantCategory from './component/merchantCategory';
import MerchantTerms from './component/merchantTNC';
import MerchantAdmin from './component/merchantAdmin';
import { reactLocalStorage } from 'reactjs-localstorage';
import { useNavigate } from 'react-router';
import MerchantMenu from './component/merchantMenu';
import { IconLock, IconLockOpen } from '@tabler/icons';
import { getFirstLetters } from 'helper/String';
import { display } from '@mui/system';
import { isSTCAdmin } from 'helper/Admin';
import { menuOptions } from 'constant/constant';


function Merchant({

}) {

    useResetMerchantWizardOnLeave();

    const MAX_SIZE = 2 * 1024 * 1024; // 2MB in bytes
    const [bounds, setBounds] = useState(null)
    const [courtImages, setCourtImages] = useState([])
    const [logoImage, setLogoImage] = useState([])
    const [bannerLink, setBannerLink] = useState([])
    const [form, setForm] = useState({
        name: "",
        photos: [],
        bannerLink: [],
        layoutPhotos: [],
        address: "",
        geoLocation: null,
        description: "",
        courts: [],
        prices: [],
        operationalHours: [],
        showSummary: false,
        frontEndLink: '',
        dashboardLink: '',
        limitedAccess: '',
        whatsAppLink: '',
        googleMapLink: '',
    })
    const [searchBox, setSearchBox] = useState(null);
    const geoLocation = {
        lat: 3.5952, lng: 98.6722
    }
    const pickAllowedMenu = (merchantInfo) =>
        merchantInfo?.settings?.allowedMenu ||
        merchantInfo?.setting?.allowedMenu ||
        [];

    const normalizeSavedTab = (saved) => {
        if (typeof saved === "string") return saved;
        const map = {
            0: "court",
            1: "rain_refund",
            2: "category",
            3: "txn_fee",
            4: "tnc",
            5: "admin",
            6: "menu",
        };
        return map[saved] || "court";
    };

    const [activeTab, setActiveTab] = useState(() =>
        normalizeSavedTab(localStorage.getItem('merchantWizardPosition') || 'court')
    );

    const [rainRefund, setRainRefund] = useState({
        status: false,
        rainRefundTime: 40,
    })
    const [joiForm, setJoiForm] = useState({
        name: null,
        courts: null,
        prices: null
    })
    const [loading, setLoading] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    let permissionInfo = JSON.parse(localStorage.getItem("user_info")).merchantInfo || null
    const navigate = useNavigate()

    const getItemStyle = (isDragging, draggableStyle) => (isDragging ? {
        userSelect: 'none',
        padding: 5,
        background: 'white',
        ...draggableStyle,
    } : { ...draggableStyle });

    const [allowedMenu, setAllowedMenu] = useState([]);
    const [menuUpdate, setMenuUpdate] = useState(true)

    // const { isLoaded } = useLoadScript({
    //   googleMapsApiKey: "AIzaSyAKrWUuRu01ZDG_y2inffSugb_e9EveAZU",
    //   libraries: ["places"]
    // });
    const center = useMemo(() => (form.geoLocation || geoLocation), [form.geoLocation]);

    const onPlacesChanged = () => {
        // console.log(searchBox.getPlaces())
        setForm(prev => ({
            ...prev,
            geoLocation: {
                lat: searchBox.getPlaces()[0].geometry.location.lat(),
                lng: searchBox.getPlaces()[0].geometry.location.lng()
            }
        }))
    };
    const onSBLoad = ref => {
        setSearchBox(ref);
    };

    const deleteCourtImages = (index) => {
        let currImages = courtImages
        let currBannerLink = bannerLink
        currImages.splice(index, 1);
        currBannerLink.splice(index, 1);
        setCourtImages(prev => ([...currImages]))
        setBannerLink(prev => ([...currBannerLink]))
    }

    const setCourt = (e) => {
        // console.log('savePrice', e)
        if (e) {
            setForm(prev => ({
                ...prev,
                ...e
            }))
        }
    }

    const TAB_DEFS = [
        { key: "court", label: "Court", perm: null },
        { key: "rain_refund", label: "Rain Refund", perm: "settings_rain_refund" },
        { key: "category", label: "Category", perm: "settings_category" },
        { key: "txn_fee", label: "Txn Fee", perm: "settings_txn_fee" },
        { key: "tnc", label: "T&C", perm: "settings_tnc" },
        { key: "admin", label: "Admin", perm: "admin" },
        { key: "menu", label: "Menu", perm: "settings_menu" },
    ];

    useEffect(() => {
        let { isEdit, params } = getParamsFromURL(window);
        if (isEdit) { getPlaceInfo(params) }
    }, [])

    useEffect(() => {
        // console.log(courtImages.length)
    }, [courtImages])

    useEffect(() => {
        // console.log(form)
        setJoiForm({
            name: !form.name ? '*' : null
        })
    }, [form])


    const hasAnySettings = (allowed = []) =>
        allowed.some((p) => typeof p === "string" && p.startsWith("settings_"));

    const allowedSet = useMemo(() => new Set(allowedMenu), [allowedMenu]);


    const tabs = useMemo(() => {
        const isAdminContext = Boolean(permissionInfo); // keep if you really need it
        if (isSTCAdmin()) { return TAB_DEFS }

        return TAB_DEFS.filter((t) => {
            if (!t.perm) return true; // court always

            // admin rule (your old behavior)
            if (t.key === "admin") return isAdminContext || allowedSet.has("admin");

            // settings tabs: show only if permission exists
            return allowedSet.has(t.perm);
        });
    }, [allowedSet, permissionInfo]);

    useEffect(() => {
        if (!tabs.length) return;
        const exists = tabs.some((t) => t.key === activeTab);
        if (!exists) {
            const next = tabs[0].key;
            setActiveTab(next);
            setMerchantWizardState(next);

        }
        if (menuUpdate) {
            getLatestTabWizzard()
        }
    }, [tabs, activeTab, menuUpdate]);

    const getPlaceInfo = async (placeId) => {
        let { data, error } = await getPlaceDetail(placeId)
        if (error) { throw error }
        if (data) {
            const mi = data.place?.merchantInfo;
            console.log('here data', data)
            // ✅ normalize
            const nextAllowed = pickAllowedMenu(mi);

            // ✅ component state (wizard tabs)
            setAllowedMenu(Array.isArray(nextAllowed) ? nextAllowed : []);

            let whatsAppLink = data.place?.merchantInfo?.whatsAppLink?.split("/") || ''
            setForm(prev => ({
                ...prev,
                ...data.place,
                frontEndLink: data.place?.merchantInfo?.frontEndLink?.split(".")[0],
                dashboardLink: data.place?.merchantInfo?.dashboardLink?.split(".")[0],
                whatsAppLink: whatsAppLink ? whatsAppLink[whatsAppLink.length - 1] : '',
                instagramLink: data.place?.instagramLink || '',
                googleMapLink: data.place?.merchantInfo?.googleMapLink || '',
                courts: data.courts,
                prices: data.prices
            }))
            console.log('data place merchantInfo', data.place.merchantInfo)
            setCourtImages(prev => ([...data.place.photos]))
            setLogoImage(prev => data.place.merchantInfo?.logo ? [data.place.merchantInfo?.logo] : [])
            if (data.place.bannerLink) {
                setBannerLink(prev => ([...data.place.bannerLink]))
            } else {
                let currBLink = []
                for (let i = 0; i < data.place.photos.length; i++) {
                    currBLink.push('')
                }
                setBannerLink(currBLink)
            }
            if (data.place && data.place.rainRefund) {
                setRainRefund({
                    ...data.place.rainRefund
                })
            }
            localStorage.setItem("allowed_menu", JSON.stringify(nextAllowed));
            window.dispatchEvent(new Event("allowed_menu_updated"));

            setActiveTab(reactLocalStorage.get("merchantWizardPosition") || "court");
        }
    }

    const getLatestTabWizzard = async () => {
        let placeId = form._id
        let { data, error } = await getPlaceDetail(placeId)
        if (data) {
            const mi = data.place?.merchantInfo;
            const nextAllowed = pickAllowedMenu(mi);
            setAllowedMenu(Array.isArray(nextAllowed) ? nextAllowed : []);
            setActiveTab(reactLocalStorage.get("merchantWizardPosition") || "court");
            setMenuUpdate(false)
        }
    }

    const checkAllowedInfo = async (placeId, newKey) => {
        let { data, error } = await getPlaceDetail(placeId);
        if (error) throw error;

        const mi = data?.place?.merchantInfo;
        const allowedMenu = pickAllowedMenu(mi);
        const allowed = Array.isArray(allowedMenu) ? allowedMenu : [];
        const allowedSet = new Set(allowed);

        // 👇 build which tabs are allowed based on API
        const showSettings = hasAnySettings(allowed);

        const isAdminContext = Boolean(permissionInfo); // keep your old rule

        const tabAllowedMap = {
            court: true,
            admin: isAdminContext || allowedSet.has("admin"),

            // settings tabs follow your rule: if any settings_* exists -> allow
            rain_refund: showSettings,
            category: showSettings,
            txn_fee: showSettings,
            tnc: showSettings,
            menu: showSettings,
        };

        const isAllowed = Boolean(tabAllowedMap[newKey]);

        if (!isAllowed) {
            toastMessage("You don't have access to this tab.", {
                toastId: `tab-no-access-${newKey}`,
                type: "error",
            });
            return false;
        }

        // ✅ allowed -> set tab
        setActiveTab(newKey);
        setMerchantWizardState(newKey);
        return true;
    };

    // bungkus saveForm dengan handler yang jaga isSaving
    const handleSave = async () => {
        if (isSaving) return              // jaga‐jaga double click
        setIsSaving(true)
        try {
            await saveForm()                // asumsikan ini return Promise
            // bisa tambahkan toast success di sini
        } catch (err) {
            console.error(err)
            // toast error atau fallback UI
        } finally {
            setIsSaving(false)
        }
    }

    const saveForm = async () => {
        setLoading(true)
        // handleUpload

        // createMerchant
        let body = {
            ...form,
        }

        if (logoImage.length > 0) {
            const logoUrl = async () => {
                if (logoImage[0].name) {
                    let images = await handleUpload(logoImage[0])
                    return images
                } else {
                    return logoImage
                }
            }
            body.merchantLogo = await logoUrl()
        }

        if (!form.merchantInfo?._id && !form._id) {
            let merchantId = await addNewMerchant({
                logo: body.merchantLogo
            })
            body = {
                ...body,
                ...(merchantId && { merchantId: merchantId })
            }
        } else {
            let merchantId = await updateCurrentMerchant({
                logo: body.merchantLogo
            })
            body = {
                ...body,
                ...(merchantId && { merchantId: merchantId })
            }
        }
        if (form._id && (form.courts.length == 0 || form.prices.length == 0)) {
            toastMessage(`${form.courts.length == 0 ? 'Courts' : form.prices.length == 0 ? 'Prices' : 'Form'} is empty`, {
                toastId: "empty-price-court",
                type: "error",
            })
            return;
        }
        if (courtImages) {
            let courtImgs = []
            for (let i = 0; i < courtImages.length; i++) {
                if (courtImages[i].name) {
                    let images = await handleUpload(courtImages[i])
                    courtImgs = courtImgs.concat(images)
                } else {
                    courtImgs = courtImgs.concat(courtImages[i])
                }
            }
            body.photos = courtImgs
        }
        body.bannerLink = bannerLink
        if (form.layoutPhotos) {
            let layoutImgs = []
            for (let i = 0; i < form.layoutPhotos.length; i++) {
                if (form.layoutPhotos[i].name) {
                    let images = await handleUpload(form.layoutPhotos[i])
                    layoutImgs = layoutImgs.concat(images)
                } else {
                    layoutImgs = layoutImgs.concat(form.layoutPhotos[i])
                }
            }
            body.layoutPhotos = layoutImgs
        }

        if (form.courts) {
            let courts = []
            for (let i = 0; i < form.courts.length; i++) {
                let newBody = form.courts[i]
                // newBody.sportCourtTypeId = form.courts[i].sportCourtTypeId
                courts.push(newBody)
            }
            body = {
                ...body,
                courts
            }
        }
        if (form.prices) {
            let prices = []
            for (let i = 0; i < form.prices.length; i++) {
                let newBody = form.prices[i]
                newBody.type = form.prices[i].type ? form.prices[i].type.value : form.prices[i].courtType ? form.prices[i].courtType : ""
                newBody.startHours = form.prices[i].startHours ? form.prices[i].startHours.value ? form.prices[i].startHours.value : form.prices[i].startHours : ""
                newBody.endHours = form.prices[i].endHours ? form.prices[i].endHours.value ? form.prices[i].endHours.value : form.prices[i].endHours : ""
                newBody.dayString = form.prices[i].days ? form.prices[i].days.value : form.prices[i].dayString ? form.prices[i].dayString : null
                newBody.day = form.prices[i].day ? form.prices[i].day : form.prices[i].days ? form.prices[i].days.number : form.prices[i].day ? form.prices[i].day : null
                prices.push(newBody)
            }
            body = {
                ...body,
                frontEndLink: form.frontEndLink,
                dashboardLink: form.dashboardLink,
                prices
            }
        }

        if (body._id) {
            // call update API
            let { data, error } = await updatePlaces(body)
            if (error) {
                console.log(error)
                toastMessage("Failed update merchant", {
                    toastId: "place-error",
                    type: "error"
                })
            }
            if (data) {
                getPlaceInfo(body._id)
                loadPlace()
                toastMessage("Success update merchant", {
                    toastId: "place-success",
                    type: "success"
                });
            }
            setLoading(false)
        } else {
            let { data, error } = await createPlaces(body)
            if (error) {
                console.log(error)
                toastMessage("Failed add new merchant", {
                    toastId: "place-error",
                    type: "error"
                })
            }
            if (data) {
                loadPlace()
                toastMessage("Success add new merchant", {
                    toastId: "place-success",
                    type: "success"
                })
                // navigate(`/${getUrlCourtCode()}/merchants/edit/${data._id}`)
            }
            setLoading(false)
        }
    }

    const loadPlace = async () => {
        let { data, error } = await getPlaces({
            isActive: true
        });
        if (error) { console.log(error) }
        if (data) {
            let court = data.map(value => ({
                id: value._id,
                name: value.name,
                code: getFirstLetters(value.name),
                merchantId: value.merchantId || '',
                title: menuOptions.find(v => v.value == value._id)?.label || getFirstLetters(value.name)
            }))

            localStorage.setItem("court_place", JSON.stringify(court))
            window.location.reload()
        }
    }

    const addNewMerchant = async ({ logo }) => {
        let { data, error } = await createMerchant({
            name: form.name,
            dashboardLink: form.dashboardLink,
            frontEndLink: form.frontEndLink,
            whatsAppLink: form.whatsAppLink,
            instagramLink: form.instagramLink,
            googleMapLink: form.googleMapLink,
            logo: logo[0]
        })
        if (error) { console.log(error) }
        if (data) return data.merchantId
    }

    const updateCurrentMerchant = async ({ logo }) => {
        console.log('here logo', logo)
        let { data, error } = await updateMerchant({
            _id: form.merchantInfo?._id,
            name: form.name,
            dashboardLink: form.dashboardLink,
            frontEndLink: form.frontEndLink,
            whatsAppLink: `${form.whatsAppLink}`,
            instagramLink: `${form.instagramLink}`,
            googleMapLink: form.googleMapLink,
            logo: logo ? logo[0] : null
        })
        return form.merchantInfo?._id
    }

    const handleOnDragEnd = (result) => {
        try {
            const { destination, source } = result;
            console.log(destination, source)

            if (!destination) return;

            // // check location change
            if (
                destination.droppableId === source.droppableId &&
                destination.index === source.index
            ) return;

            // // reoder 
            const newImageRows = Array.from(courtImages);
            const newBannerRows = Array.from(bannerLink);
            const [removed] = newImageRows.splice(source.index, 1);
            const [removedLink] = newBannerRows.splice(source.index, 1);
            newImageRows.splice(destination.index, 0, removed);
            newBannerRows.splice(destination.index, 0, removedLink)
            setCourtImages(newImageRows);
            setBannerLink(newBannerRows);

        } catch (error) {
            console.error(error);
        }
    }

    const saveRainRefund = async () => {
        try {
            if (!form.merchantId) {
                toastMessage('Court is invalid', {
                    toastId: "rain-error",
                    type: "error"
                });
            }
            let { data, error } = await setMerchantRainRefund({
                merchantId: form.merchantId,
                ...rainRefund
            })
            if (data) {
                toastMessage('Update refund time success', {
                    toastId: "rain-success",
                    type: "success"
                });
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Tabs
                orientation='horizontal'
                variant='scrollable'
                scrollButtons={false}
                value={activeTab}
                sx={{ m: 0, mb: 0 }}
                onChange={(e, newKey) => {
                    // let { params } = getParamsFromURL(window);
                    // await checkAllowedInfo(params, newKey)
                    setActiveTab(newKey);
                    setMerchantWizardState(newKey);
                    setMenuUpdate(true)
                }}
            >
                {tabs.map((t) => (
                    <Tab
                        key={t.key}
                        value={t.key}
                        label={t.label}
                        style={{
                            backgroundColor: activeTab === t.key ? "white" : "",
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                        }}
                    />
                ))}
            </Tabs>
            {activeTab === "court" &&
                <Grid container xs={12} md={12}>
                    <Card sx={{ mb: 3, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                        <Box
                            sx={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                py: 4.5,
                            }}
                        >
                            <Grid container>
                                <Grid container xs={12} md={8} alignItems={"flex-start"}>
                                    <Grid item container sx={{
                                        p: 2, pb: 0
                                    }}>
                                        <Grid item xs={12} md={12} sx={{
                                            p: 1, pb: 0
                                        }}>
                                            <TCLabel style={{ display: 'flex' }}>Banner <TCLabel subtitle style={{ marginLeft: 2 }}> (1240×698 px / ratio 16:9)</TCLabel></TCLabel>
                                            <DropZoneComponent
                                                className="drop-zone"
                                                uploadName='courtImage'
                                                file={courtImages}
                                                isMultiple={true}
                                                onDrop={(files, event) => {
                                                    let currImages = courtImages ? courtImages : []
                                                    const validFiles = [];
                                                    const tooBigFiles = [];

                                                    for (let i = 0; i < files.length; i++) {
                                                        if (files[i].size > MAX_SIZE) {
                                                            tooBigFiles.push(files[i]);
                                                        } else {
                                                            validFiles.push(files[i]);
                                                        }
                                                    }

                                                    if (tooBigFiles.length) {
                                                        alert(
                                                            `These files are bigger than 2MB:\n` +
                                                            tooBigFiles.map((f) => `${f.name} (${(f.size / 1024 / 1024).toFixed(2)}MB)`).join('\n')
                                                        );
                                                    }

                                                    const nextImages = currImages.concat(validFiles);
                                                    // const nextBLink = nextImages.map((_, idx) => (bannerLink?.[idx] ? bannerLink[idx] : ''));

                                                    setCourtImages(nextImages);
                                                }}
                                            >
                                                <div className='dropzone mb-0' style={{
                                                    textAlign: 'center',
                                                    minHeight: '150px'
                                                }}>
                                                    <div style={{ padding: 10, alignItems: 'center' }}>
                                                        <label>
                                                            <i className='fa fa-upload mr-1' />
                                                            {/* need to check the image size */}
                                                            Drop image to upload (less than 2 MB)
                                                        </label>
                                                        <br />
                                                        <label
                                                            htmlFor={"courtImage"}
                                                            style={{ cursor: 'pointer' }}
                                                            className='dropzone-child mb-0'>
                                                            or Click to Browse
                                                        </label>
                                                        <div style={{ overflowX: 'auto' }}>
                                                            {
                                                                (courtImages && courtImages.length > 0) &&
                                                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                                                    <Droppable droppableId={'place-image-dnd'}>
                                                                        {(provided) => (
                                                                            <div {...provided.droppableProps} ref={provided.innerRef} style={{ textAlign: 'left' }} >
                                                                                Uploaded file :
                                                                                {
                                                                                    courtImages.map((value, index) => {
                                                                                        return (<Draggable key={`${value.name}${index}`} draggableId={`${value.name}${index}`} index={index}>
                                                                                            {(providedDrag, snapshotDrag) => (
                                                                                                <div key={`${value.name}${index}`}
                                                                                                    ref={providedDrag.innerRef}
                                                                                                    {...providedDrag.draggableProps}
                                                                                                    {...providedDrag.dragHandleProps}
                                                                                                    style={{
                                                                                                        ...getItemStyle(snapshotDrag.isDragging, providedDrag.draggableProps.style),
                                                                                                        display: 'flex', textAlign: 'left', background: 'transparent',
                                                                                                        paddingTop: 8
                                                                                                    }}>
                                                                                                    <img src={(!value.name && value.includes("https")) ? value : URL.createObjectURL(value)} style={{ minWidth: '100px', maxHeight: '50px', objectFit: 'contain', marginRight: 10 }}
                                                                                                        onClick={() => { }} alt=''/>
                                                                                                    <div pt={1} style={{ minWidth: '40%' }}>
                                                                                                        {/* <TCInput value={bannerLink[index]}/> */}
                                                                                                        <TCLabel style={{
                                                                                                            fontSize: 10
                                                                                                        }}>{`Banner-${index + 1} Link to Url`}</TCLabel>
                                                                                                        <TCInput value={
                                                                                                            bannerLink[index] || ''
                                                                                                        } onChange={(e) => {
                                                                                                            let currBLink = bannerLink
                                                                                                            currBLink[index] = e.currentTarget.value
                                                                                                            setBannerLink(prev => [
                                                                                                                ...currBLink
                                                                                                            ])
                                                                                                        }} />
                                                                                                    </div>
                                                                                                    <div style={{
                                                                                                        alignItems: 'center',
                                                                                                        alignSelf: 'center',
                                                                                                        paddingTop: 20,
                                                                                                        width: 50, height: 50,
                                                                                                    }}>
                                                                                                        <label style={{ alignItems: 'flex-end' }}>
                                                                                                            <span style={{
                                                                                                                marginLeft: 5, color: 'gray', cursor: 'pointer',
                                                                                                                paddingTop: 15, paddingLeft: 15, paddingRight: 15,
                                                                                                                paddingBottom: 15,
                                                                                                                width: 50, height: 50,
                                                                                                            }} onClick={() => {
                                                                                                                deleteCourtImages(index)
                                                                                                            }}>X</span>
                                                                                                        </label>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </Draggable>
                                                                                        )
                                                                                    })
                                                                                }
                                                                                {provided.placeholder}
                                                                            </div>
                                                                        )}
                                                                    </Droppable>
                                                                </DragDropContext>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </DropZoneComponent>
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction={"row"} sx={{
                                        p: 2, pt: 0
                                    }}>
                                        {/* <Grid xs={12} md={12} item sx={{
                                            p: 1
                                        }}> */}
                                        {/* Upload Logo */}
                                        {/* <TCInput fullWidth={true} onChange={(e) => {
                                                if (e.currentTarget.value.length > 51) return
                                                setCourt({ name: e.currentTarget.value })
                                            }} label={"Place Name"} value={form.name}
                                                inputProps={{ maxLength: 50 }} /> */}
                                        {/* </Grid> */}
                                        <Grid xs={12} md={12} item sx={{
                                            p: 1
                                        }}>
                                            <TCInput fullWidth={true} onChange={(e) => {
                                                if (e.currentTarget.value.length > 51) return
                                                setCourt({ name: e.currentTarget.value })
                                            }} label={"Merchant Name"} value={form.name}
                                                inputProps={{ maxLength: 50 }} />
                                        </Grid>
                                        <Grid item xs={12} md={12} sx={{
                                            p: 1
                                        }}>
                                            <TCInput fullWidth={true} onChange={(e) => {
                                                setCourt({ address: e.currentTarget.value })
                                            }} label={"Address"} value={form.address} type={'textarea'} rows={2} maxRows={2} />
                                        </Grid>
                                        <Grid container item xs={12} md={12} sx={{
                                            p: 1, display: 'flex'
                                        }}>
                                            <Grid item xs={12}>
                                                <TCLabel>{"WhatsApp Link"}</TCLabel>
                                            </Grid>
                                            <Grid container spacing={1}>
                                                <Grid item width={110}>
                                                    <TCInput disabled value={'https://wa.me/'} />
                                                </Grid>
                                                <Grid item sx={{ pl: 1 }}>
                                                    <TCInput fullWidth={true} onChange={(e) => {
                                                        setCourt({ whatsAppLink: e.currentTarget.value })
                                                    }} value={form.whatsAppLink} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid container item xs={12} md={12} sx={{
                                            p: 1, display: 'flex'
                                        }}>
                                            <Grid item xs={12}>
                                                <TCLabel>{"Instagram Link"}</TCLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <TCInput fullWidth={true} onChange={(e) => {
                                                    setCourt({ instagramLink: e.currentTarget.value })
                                                }} value={form.instagramLink} />
                                            </Grid>
                                        </Grid>
                                        <Grid container item xs={12} md={12} sx={{
                                            p: 1, display: 'flex'
                                        }}>
                                            <Grid item xs={12}>
                                                <TCLabel>{"Google Map Link"}</TCLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <TCInput fullWidth={true} onChange={(e) => {
                                                    setCourt({ googleMapLink: e.currentTarget.value })
                                                }} value={form.googleMapLink} />
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} sx={{
                                            p: 1
                                        }}>
                                            <TCInput fullWidth={true} label={"Description"} type={'textarea'} rows={4} maxRows={6} onChange={(e) => {
                                                setCourt({ description: e.currentTarget.value })
                                            }} value={form.description} />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Grid item xs={12} md={12} sx={{
                                                p: 1, pb: 0
                                            }}>
                                                <TCLabel>Merchant Logo</TCLabel>
                                                <DropZoneComponent
                                                    className="drop-zone"
                                                    uploadName='logoImage'
                                                    file={logoImage}
                                                    isMultiple={false}
                                                    onDrop={(files, event) => {
                                                        console.log('here images,', files)
                                                        if (files[0].size > MAX_SIZE) {
                                                            alert(
                                                                `These files are bigger than 2MB:\n` +
                                                                `${files[0].name} (${(files[0].size / 1024 / 1024).toFixed(2)}MB)`
                                                            );
                                                        }
                                                        setLogoImage(files)
                                                    }}
                                                >
                                                    <div className='dropzone mb-0' style={{
                                                        textAlign: 'center',
                                                        minHeight: '150px'
                                                    }}>
                                                        <div style={{ padding: 10, alignItems: 'center' }}>
                                                            <label>
                                                                <i className='fa fa-upload mr-1' />
                                                                {/* need to check the image size */}
                                                                Drop image to upload (less than 2 MB)
                                                            </label>
                                                            <br />
                                                            <label
                                                                htmlFor={"logoImage"}
                                                                style={{ cursor: 'pointer' }}
                                                                className='dropzone-child mb-0'>
                                                                or Click to Browse
                                                            </label>
                                                            <div style={{ overflowX: 'auto' }}>
                                                                {
                                                                    logoImage.length > 0 &&
                                                                    <div key={`${logoImage[0].name}${1}`}
                                                                        style={{
                                                                            display: 'flex', textAlign: 'left', background: 'transparent',
                                                                            paddingTop: 8
                                                                        }}>
                                                                        <img src={(!logoImage[0].name && logoImage[0].includes("https")) ? logoImage[0] : URL.createObjectURL(logoImage[0])} style={{ minWidth: '100px', maxHeight: '50px', objectFit: 'contain' }}
                                                                            onClick={() => { }} alt=''/>
                                                                        <div style={{
                                                                            alignItems: 'center',
                                                                            alignSelf: 'center',
                                                                            display: 'flex',
                                                                            height: 50,
                                                                        }}>
                                                                            <TCLabel style={{
                                                                                fontSize: 10
                                                                            }}>{`Logo-${1} Link to Url`}</TCLabel>
                                                                            <label style={{ alignItems: 'flex-end' }}>
                                                                                <span style={{
                                                                                    color: 'gray', cursor: 'pointer',
                                                                                    paddingTop: 15, paddingLeft: 5, paddingRight: 15,
                                                                                    paddingBottom: 15,
                                                                                    width: 50, height: 50,
                                                                                }} onClick={() => {
                                                                                    setLogoImage([])
                                                                                }}>X</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </DropZoneComponent>
                                            </Grid>
                                        </Grid>
                                        <Grid container item xs={12} md={12} sx={{
                                            p: 1, display: 'flex'
                                        }}>
                                            <Grid item xs={12}>
                                                <TCLabel>{"Frontend Link"}</TCLabel>
                                            </Grid>
                                            <Grid container spacing={1}>
                                                <Grid item>
                                                    <TCInput fullWidth={true} onChange={(e) => {
                                                        setCourt({ frontEndLink: e.currentTarget.value, dashboardLink: e.currentTarget.value })
                                                    }} value={form.frontEndLink} />
                                                </Grid>
                                                <Grid item sx={{ pl: 1 }}>
                                                    <TCInput disabled value={'.top-court.com'} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid container xs={12} md={12} sx={{
                                            p: 1, display: 'flex'
                                        }}>
                                            <Grid item xs={12}>
                                                <TCLabel>{"Dashboard Link"}</TCLabel>
                                            </Grid>
                                            <Grid container spacing={1}>
                                                <Grid item>
                                                    <TCInput fullWidth={true} disabled onChange={(e) => {
                                                        setCourt({ dashboardLink: e.currentTarget.value })
                                                    }} value={form.dashboardLink} />
                                                </Grid>
                                                <Grid item sx={{ pl: 1 }}>
                                                    <TCInput disabled value={'.top-court.com'} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} md={12} sx={{
                                            p: 1
                                        }}>
                                            <TCLabel>Dashboard Browser ID</TCLabel>
                                            <Grid container spacing={1}>
                                                <Grid item mt={0.8}>
                                                    {
                                                        form.limitedAccess ? <IconLock color={"#f44336"} /> : <IconLockOpen color={"#69f0ae"} />
                                                    }
                                                </Grid>
                                                <Grid item xs>
                                                    <TCInput label={""} value={form.limitedAccess} onChange={(e) => setCourt({ limitedAccess: e.currentTarget.value.trim() })} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item sx={{ textAlign: 'left', pl: 0, pr: 0, p: 1 }}>
                                            <TCLabel>Status</TCLabel>
                                            <Grid mt={-0.8} ml={-1}>
                                                <Switch disabled={form?._id?.toString() === '653f5d9006520fccd4ab4604'} checked={form.isActive} onChange={() => {
                                                    if (form?._id?.toString() === '653f5d9006520fccd4ab4604') { return; }
                                                    setCourt({ isActive: !form.isActive })
                                                }} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12} md={6} lg={4}>
                                    <Grid container direction={"row"} sx={{
                                        p: 2, pt: 0
                                    }}>
                                        <Grid item sx={{
                                            p: 1,
                                            mt: 1
                                        }}>
                                            <TCTitleLabel>Status and Operational Hours</TCTitleLabel>
                                            <OperationalHoursComponent setCourt={setCourt} currOpsHours={form.operationalHours} showSummary={form.showSummary} setShowSummary={setCourt} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                        {
                            form._id &&
                            <Box>
                                <AddCourtComponent
                                    setCourt={setCourt}
                                    formImages={form.layoutPhotos}
                                    courtInfo={form.courts}
                                    priceList={form.prices}
                                    merchantId={form.merchantId}
                                    formId={form._id} />
                            </Box>
                        }
                        <Grid sx={{ p: 2 }} justifyContent={"flex-end"} textAlign={"right"}>
                            {/* <Button variant='contained' onClick={() => { saveForm() }}>Update</Button> */}
                            <LoadingButton
                                onClick={handleSave}
                                loading={isSaving}
                                loadingIndicator="Saving..."      // teks yang muncul saat loading
                                loadingPosition="end"            // bisa "start" atau "end"
                                variant="contained"
                            >
                                Save
                            </LoadingButton>
                        </Grid>
                    </Card>
                </Grid >
            }
            {
                (activeTab === "rain_refund" && form._id) &&
                <Grid container xs={12} md={12}>
                    <Card sx={{ mb: 3, width: '100%', borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                        <Box sx={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            py: 4.5,
                            px: 2
                        }}>
                            <Grid container>
                                <Grid item>
                                    <TCInput label={"Outdoor: Rain Refund Time (mins)"}
                                        // disabled={selectValuePack}
                                        disabled={!rainRefund.status}
                                        value={!rainRefund.status ? '' : rainRefund.rainRefundTime}
                                        placeHolder={!rainRefund.status ? "Rain Refund not active" : "Input Refund Time in mins"}
                                        onChange={(e) => {
                                            if (e.currentTarget.value) {
                                                if (!validation.isNumber(e.currentTarget.value)) { return; }
                                                let value = Number(e.currentTarget.value)
                                                if (value > 60) { value = 60 }
                                                // setCouponCode(e.currentTarget.value.toUpperCase().trim())
                                                // setRainRefund(value)
                                                setRainRefund((prev) => ({
                                                    ...prev,
                                                    rainRefundTime: value
                                                }))
                                            } else {
                                                setRainRefund((prev) => ({
                                                    ...prev,
                                                    rainRefundTime: e.currentTarget.value
                                                }))
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item sx={{ textAlign: 'center', p: 1, pt: 0 }}>
                                    <TCLabel>Status</TCLabel>
                                    <Switch checked={rainRefund.status} onChange={() => {
                                        setRainRefund((prev) => ({
                                            ...prev,
                                            status: !rainRefund.status
                                        }))
                                    }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button sx={{ mt: 1 }} variant='contained' onClick={() => { saveRainRefund() }}>Update</Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Card>
                </Grid>
            }
            {
                (activeTab === "category" && form._id) && (
                    permissionInfo ?
                        <MerchantAdmin merchantId={form.merchantId} placeId={form._id} merchantCode={form.merchantInfo?.merchantId} />
                        :
                        <MerchantCategory merchantId={form.merchantId} placeId={form._id} merchantInfo={form.merchantInfo} />
                )
            }
            {
                (activeTab === "txn_fee" && form._id) &&
                <MerchantPartnerFee merchantId={form.merchantId} />
            }
            {
                (activeTab === "tnc" && form._id) &&
                <MerchantTerms merchantId={form.merchantId} placeId={form._id} />
            }
            {
                (activeTab === "admin" && form._id) &&
                <MerchantAdmin merchantId={form.merchantId} placeId={form._id} merchantCode={form.merchantInfo?.merchantId} />
            }
            {
                (activeTab === "menu" && form._id) &&
                <MerchantMenu merchantId={form.merchantId} allowedMenu={form.merchantInfo?.settings?.allowedMenu} />
            }
        </>
    )
}

export default Merchant;
